var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "rb-useful-link",
      attrs: {
        href: _vm.href,
        "data-element-id": _vm.dataElementId,
        "data-description": _vm.dataDescription,
      },
    },
    [
      _c(
        "span",
        { staticClass: "rb-useful-link__label" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("rb-lazy-icon", {
        staticClass: "rb-useful-link__icon",
        attrs: { icon: "arrow-right--bold" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }